(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookNode', HandbookNode);

    HandbookNode.$inject = ['$resource'];

    function HandbookNode ($resource) {
        var resourceUrl =  'api/handbook-nodes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
